// src/pages/SocialLoginCallback.tsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAuthToken } from '../../services/apiClient'; // axios インスタンスを設定する関数

export default function SocialLoginCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get('access');
    const refresh = params.get('refresh');

    if (access && refresh) {
      /* ① sign_up 完了イベントを GA4 へ送信 */
      window.dataLayer?.push({
        event: 'sign_up',
        method: 'line'
      });
      // トークンを localStorage に保存
      localStorage.setItem('auth_token', access);
      localStorage.setItem('refresh_token', refresh);
      // axios インスタンスにもセット
      setAuthToken(access);
      // 認証済みページへ遷移（例：ホーム画面）
      navigate('/', { replace: true });
    } else {
      // パラメータ不足ならログイン画面へ
      navigate('/login', { replace: true });
    }
  }, [location.search, navigate]);

  return <div>ログイン処理中…</div>;
}
